var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader__line",class:{'preloader__line--start': _vm.preloaderStart && !_vm.preloaderHide, 'preloader__line--end': _vm.preloaderEnd && !_vm.preloaderHide}})])
}
var staticRenderFns = []

export { render, staticRenderFns }